export default {
   EXHIBITION_AREA_PDF_SIZE   :  32096088,
   EXHIBITION_AREA_VIDEO_SIZE :  524288000
}
